module.exports = {"version":2,"waiters":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/pricing-2017-10-15.waiters2.json
// module id = 580
// module chunks = 0